// extracted by mini-css-extract-plugin
module.exports = {"tags":"product-tags_tags__ABwHt","tags-container":"product-tags_tags-container__LZ5CP","tags-pill":"product-tags_tags-pill__Hkq5H"};